module.exports = __webpack_public_path__ + "img/icb-leo-novice-m.6864758a.png";